/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseMediaWithScrollableTextFragment} from '@amblique/contentful/app/contentful/fragments/media-with-scrollable-text/base-media-with-scrollable-text.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseScrollableTextFragment} from '@amblique/contentful/app/contentful/fragments/scrollable-text/base-scrollable-text.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const MediaWithScrollableTextFragment = gql`
  ${BaseImageFragment}
  ${BaseMediaWithScrollableTextFragment}
  ${BaseScrollableTextFragment}
  ${BaseVideoFragment}

  fragment MediaWithScrollableTextFragment on MediaWithScrollableText {
    ...BaseMediaWithScrollableTextFragment

    backgroundMedia {
      ... on Image {
        ...BaseImageFragment
      }
      ... on Video {
        ...BaseVideoFragment
      }
    }
    backgroundMediaMobile {
      ... on Image {
        ...BaseImageFragment
      }
      ... on Video {
        ...BaseVideoFragment
      }
    }
    scrollableTextCollection {
      items {
        __typename
        ... on ScrollableText {
          ...BaseScrollableTextFragment
        }
      }
    }
    scrollableTextCursorCollection {
      items {
        __typename
        ... on ScrollableText {
          ...BaseScrollableTextFragment
        }
      }
    }
  }
`;
